"use client";
import Image from "next/image";
import { ArrowRight } from "lucide-react";

const BottomBanner = () => {
  return (
    <section className="w-full bg-background-primary !px-6 md:!px-6 !py-8 md:!py-12 lg:max-h-[280px] mb-20!">
      <div className="!mx-auto max-w-[4000px]">
        <div className="relative w-full rounded-xl  overflow-hidden bg-[#150a32] shadow-2xl flex flex-col md:flex-row items-center justify-between !p-8 md:!p-10  ">
          <div className="relative block lg:hidden w-full h-[260px] sm:h-[340px]">
            <Image src="/images/Global_Event/bottombanner.webp" alt="Global Events Map Banner" fill priority className="object-cover object-right opacity-80 mix-blend-screen" />
          </div>

          <div className="absolute inset-0 w-full h-full z-0 pointer-events-none hidden lg:block">
            <Image src="/images/Global_Event/bottombanner.webp" alt="Bottom Banner Background" fill className="object-fill object-center " priority />
          </div>

          <div className="  absolute inset-0 z-[1]  bg-gradient-to-r  from-[#120824] via-[#120824]/85 to-[#120824]/35  lg:from-[#120824] lg:via-[#120824]/75 lg:to-transparent  hidden lg:block" />
          <div className="relative z-10 w-full flex flex-col items-start !gap-6 min-[2560px]:!gap-16">
            <h2 className="text-xl md:text-[20px] min-[2560px]:text-[54px] font-medium min-[2560px]:font-medium text-white leading-relaxed min-[2560px]:leading-[1.2] max-w-[450px] min-[2560px]:max-w-[1300px]">
              From global summits to local meetups — we're always where innovation happens.
            </h2>
            <p className="text-xl md:text-[15px]  font-medium min-[2560px]:font-medium text-white leading-relaxed min-[2560px]:leading-[1.2] max-w-[450px] min-[2560px]:max-w-[1300px]">
              Engaging with the global tech community through conferences, networking events, workshops, and industry meetups that inspire collaboration, innovation, and
              future-focused digital conversations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomBanner;
